<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-container>
                <v-data-table
                    :headers="headers"
                    :items="users"
                    class="all-users-table"
                    :loading="loading"
                    :options.sync="options"
                    @page-count="pageCount = $event"
                    :hide-default-footer="true"
                >
                    <template v-slot:item.email="{ item }">
                        <a 
                            class="col-link"
                            @click="$router.push({
                                name: 'UserProfile',
                                params: { id: item.id }
                            })"
                        > {{ item.email }}</a>
                    </template>
                </v-data-table>
            </v-container>

            <div class="text-center pt-2 table-pagination">
                <v-pagination v-model="options.page" :length="pageCount" :total-visible="6" 
                ></v-pagination>
            </div>

        </v-flex>

    </v-layout>
</template>

<script>
    export default {
        name: "AllCancerUsers",
        data () {
            return {
                pageCount: 0,
                headers: [
                    {
                        text: 'NOMBRE',
                        align: 'start',
                        value: 'name'
                    },
                    {
                        text: 'APELLIDOS',
                        align: 'start',
                        value: 'lastname'
                    },
                    {
                        text: 'CORREO-E',
                        align: 'start',
                        value: 'email'
                    },
                    {
                        text: 'ÚLTIMO REPORTE',
                        value: 'last_reported'
                    }
                ]
            }
        },
        computed: {
            users() {
                return this.$store.getters['users/list']
            },
            loading() {
                return this.$store.getters['users/loading']
            },
            options: {
                get: function () {
                  return this.$store.getters['users/options']
                },
                set: function (newValue) {
                  this.$store.commit('users/setOptions', newValue)
                }
            },
        },
        mounted() {
            this.$store.dispatch('users/loadListCancer')
        },
    }
</script>

<style lang="scss" scoped>
    a.col-link {
        color: #222c68 !important;
    }
    .symptoms-text {
        font-weight: 600;
    }
    .last_report-text {
        font-size: 1rem;
    }
    span.is-intervened {
        color: #1b99d3;
        font-weight: 600;
    }
    span.not-intervened {
        color: #727b87;
    }
</style> 